import { SThemeProvider } from "@avalara/skylab-sdk/react";
import React from "react";
import { useThemeSwitcherFeatureFlag } from "../features/sharedComponents/useThemeSwitcherFeatureFlag";
import isOneWebDomainRuntime from "../shared/avaAppRuntime";

/** Default Skylab appearance when the standalone theme switcher is enabled. */
const STANDALONE_THEME_APPEARANCE = "dark" as const;

interface AppThemeProviderProps {
    children: React.ReactNode;
}

/**
 * Standalone ECM: wraps with Skylab `SThemeProvider` when the theme switcher feature flag
 * is enabled. One Web Domain (AvaApp): passes children through — the shell owns theme.
 */
const AppThemeProvider = ({ children }: AppThemeProviderProps): React.JSX.Element => {
    const isThemeSwitcherEnabled = useThemeSwitcherFeatureFlag();

    if (isOneWebDomainRuntime() || !isThemeSwitcherEnabled) {
        return <>{children}</>;
    }

    return <SThemeProvider appearance={STANDALONE_THEME_APPEARANCE}>{children}</SThemeProvider>;
};

export default AppThemeProvider;
